define("ItemRecSys", ["require", "exports", "SuiteCommerce.ItemRecSys.WidgetCct"], function (require, exports, WidgetCct_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            WidgetCct_1.WidgetCct.mountToApp(container);
        },
    };
});
